import React, { forwardRef } from "react";

const Footer = forwardRef(function Footer(props, ref) {
    return (
        <footer ref={ref} className="w-full fixed bottom-0 flex flex-row justify-center items-center bg-gray-300 border-gray-200 h-5 z-40">
            <span className="text-xs text-gray-700">Version 2.3.2</span>
        </footer>
    );
});

export default Footer;
